import _axios from "../../platform";
import qs from 'qs'


export const qlwsList = params =>
    _axios({
        url: '/qlws/api/applyRecord/search',
        method: "get",
        params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {arrayFormat: "repeat"});
        },
    });

export const eviList = params =>
    _axios({
        url: '/evidence/api/search',
        method: "get",
        params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {arrayFormat: "repeat"});
        },
    });

export const opusList = data =>
    _axios({
        url: '/opus/api/opus',
        method: "post",
        params: data
    });

export const emailList = params =>
    _axios({
        url: '/email/api/emailProof/search',
        method: "get",
        params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {arrayFormat: "repeat"});
        },
    });

export const currentTime = params =>
    _axios({
        url: '/content-plus/api/time/currentTime',
        method: "get",
        params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {arrayFormat: "repeat"});
        },
    });
